const style = (theme) => {
  const output = {
    zoomControl: {
      position: 'absolute',
      zIndex: 1,
      top: 25,
      right: '5.5vw',
      display: 'flex',
      flexDirection: 'column',
      '& > *': {
        borderRadius: '50%',
        backgroundColor: theme.colors[1],
        width: 40,
        height: 40,
        cursor: 'pointer',
        boxShadow: `0px 0px 10px 1px ${theme.getRgba(theme.colors[0], 0.2)}`,
        '&:not(:last-child)': {
          marginBottom: 10,
        },
      },
    },
    zoomControlPlus: {
      position: 'relative',
      zIndex: 1,
      '&::before': {
        content: '""',
        position: 'absolute',
        zIndex: 1,
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 8,
        height: 2,
        background: theme.colors[0],
      },
      '&::after': {
        content: '""',
        position: 'absolute',
        zIndex: 1,
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 2,
        height: 8,
        background: theme.colors[0],
      },
    },
    zoomControlMinus: {
      position: 'relative',
      zIndex: 1,
      '&::before': {
        content: '""',
        position: 'absolute',
        zIndex: 1,
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 8,
        height: 2,
        background: theme.colors[0],
      },
    },
  }

  /*------------------------------
  MD
  ------------------------------*/
  output[theme.mediaInverse.md] = {}

  /*------------------------------
  SM
  ------------------------------*/
  output[theme.mediaInverse.sm] = {}

  return output
}
export default style
